import React from "react";

export default function Footer() {
  return (
    <div className="footer">
      Designed by <a href="https://github.com/aditi-hinge">Aditi Hinge</a>
    </div>
  );
}
